export class QuestionInBlockDto {

      questionInBlockId;
      questionContent;
      active;
      creationPerson;
      creationDate;
      modificationPerson;
      modificationDate;
      orderNumber;
      abbrev;
      additional;
      block;
      answers;
      blockInList;
}
